import { render, staticRenderFns } from "./AdminChat.vue?vue&type=template&id=0a66afc5&scoped=true&"
import script from "./AdminChat.vue?vue&type=script&lang=js&"
export * from "./AdminChat.vue?vue&type=script&lang=js&"
import style0 from "./AdminChat.vue?vue&type=style&index=0&id=0a66afc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66afc5",
  null
  
)

export default component.exports